import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Stack, HStack, VStack } from "@chakra-ui/react";
export var StartStack = function(stackProps) {
    return /*#__PURE__*/ _jsx(Stack, _object_spread({
        align: "flex-start"
    }, stackProps));
};
export var EndStack = function(stackProps) {
    return /*#__PURE__*/ _jsx(Stack, _object_spread({
        align: "flex-end"
    }, stackProps));
};
export var CenterStack = function(stackProps) {
    return /*#__PURE__*/ _jsx(Stack, _object_spread({
        align: "center"
    }, stackProps));
};
export var FullHStack = function(stackProps) {
    return /*#__PURE__*/ _jsx(HStack, _object_spread({
        align: "stretch"
    }, stackProps));
};
export var FullVStack = function(stackProps) {
    return /*#__PURE__*/ _jsx(VStack, _object_spread({
        align: "stretch"
    }, stackProps));
};
